/* eslint-disable */
<template>
  <div>
    <table
      cellspacing="0"
      cellpadding="0"
      border="0"
      role="presentation"
      style="font-size: 0; line-height: 1.5;width:100%;"
    >
      <tbody>
        <tr>
          <td>
            <img
              v-if="this.basic.marketplace.country"
              style="height:30px;"
              :src="marketplaces.marketplaces.filter((key)=>{return key.lang == this.basic.marketplace.country})[0].logo"
            >
          </td>
          <td
            style="text-align:right;vertical-align:bottom;"
          >
            <a
              v-if="this.basic.marketplace.country"
              style="font-family:Arial,Helvetica,sans-serif;font-size:14px;color:#1662C6;line-height: 22px;text-decoration:none;"
              :href="marketplaces.marketplaces.filter((key)=>{return key.lang == this.basic.marketplace.country})[0].link"
            >
              {{ marketplaces.marketplaces.filter((key)=>{return key.lang == this.basic.marketplace.country})[0].link.substr(8) }}
            </a>
          </td>
        </tr>
        <tr>
          <td>
            <hr style="border-bottom:none;border-top:1px solid #E4E4E4;margin:20px 0;">
          </td>
          <td>
            <hr style="border-bottom:none;border-top:1px solid #E4E4E4;margin:20px 0;">
          </td>
        </tr>
      </tbody>
    </table>
    <table
      cellspacing="0"
      cellpadding="0"
      border="0"
      role="presentation"
      style="font-size: 0; line-height: 1.5"
    >
      <tbody>
        <!-- Avatar column -->
        <tr>
          <td style="vertical-align: top;">
            <avatar
              :show-avatar="showAvatar"
              :src="image"
              :size="options.avatar.size"
              :roundness="options.avatar.roundness"
            />
          </td>
          <!-- Info column -->
          <td style="vertical-align: top;">
            <table
              cellspacing="0"
              cellpadding="0"
              border="0"
              role="presentation"
              style="font-size: 0;"
            >
              <tbody>
                <!-- Name and job fields -->
                <tr>
                  <td>
                    <span
                      style="font-family:Arial;font-size:20px;color:#1B2734"
                    >{{ mainFields[0].value }}</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span
                      style="font-family: Arial,Helvetica,sans-serif;font-size: 14px;color: #627282;"
                    >
                      {{ mainFields[1].value }}
                    </span>
                  </td>
                </tr>

                <!-- Other fields -->
                <tr>
                  <td>
                    <table
                      v-if="otherFields"
                      cellspacing="0"
                      cellpadding="0"
                      border="0"
                      role="presentation"
                      style="margin-top: 5px; font-size: 0;"
                    >
                      <tr>
                        <td>
                          <span
                            v-for="item in otherFields"
                            :key="item.name"
                          >
                            <span
                              v-if="item.type === 'phone' && item.value"
                              :style="fontBase"
                            >{{ item.value }}<span
                              v-if="item.name=='Phone1'"
                              class="separator"
                              :style="fontBase"
                            >&nbsp; |&nbsp;</span></span>
                          </span>
                        </td>
                      </tr>
                      <template v-for="item in otherFields">
                        <tr
                          v-if="item.value"
                          :key="item.name"
                        >
                          <td>
                            <a
                              v-if="item.type === 'email'"
                              :href="`mailto:${item.value}`"
                              :style="fontLink"
                            >{{ item.value }}</a>
                            <span
                              v-if="item.name === 'Address'"
                              :style="fontBase"
                              v-html="item.value"
                            />
                            <span
                              v-else-if="item.type === 'text'"
                              :style="fontBase"
                            >{{ item.value }}</span>
                          </td>
                        </tr>
                      </template>
                    </table>
                  </td>
                </tr>
                <!-- Social icons -->
                <tr v-if="items">
                  <td>
                    <table
                      cellspacing="2"
                      cellpadding="0"
                      border="0"
                      role="presentation"
                      style="margin-top: 5px; margin-left: -2px; font-size: 0;"
                    >
                      <tbody>
                        <tr>
                          <td
                            v-for="item in items"
                            :key="item.name"
                            align="center"
                            style="width: 24px; height: 24px; "
                          >
                            <a :href="formatLink(item.link)">
                              <img
                                width="24px"
                                :src="item.src"
                                :alt="`social-icon-${item.icon}`"
                                style="display: table-cell; vertical-align: middle;"
                              >
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Addons -->
    <table
      v-if="isAdded('mobileApp')"
      cellspacing="0"
      cellpadding="0"
      border="0"
      role="presentation"
      style="margin-top: 10px; font-size: 0;"
    >
      <tbody>
        <tr>
          <td v-if="addons.mobileApp.appStore.link">
            <a :href="addons.mobileApp.appStore.link">
              <img
                :src="addons.mobileApp.appStore.img"
                style="height:35px; margin-right: 5px;"
                alt="app store badge"
              >
            </a>
          </td>
          <td v-if="addons.mobileApp.googlePlay.link">
            <a :href="addons.mobileApp.googlePlay.link">
              <img
                :src="addons.mobileApp.googlePlay.img"
                style="height:35px;"
                alt="google play badge"
              >
            </a>
          </td>
        </tr>
      </tbody>
    </table>
    <table
      v-if="isAdded('banner')"
      cellspacing="0"
      cellpadding="0"
      border="0"
      role="presentation"
      style="font-size: 0; margin-top: 10px; width: 100%;"
    >
      <tbody>
        <tr v-if="addons.banner.image">
          <td>
            <a
              v-if="addons.banner.link"
              :href="formatLink(addons.banner.link)"
            >
              <img
                :src="addons.banner.image"
                alt="banner"
                style="max-width: 100%"
              >
            </a>
            <img
              v-else
              :src="addons.banner.image"
              alt="banner"
              style="max-width: 100%"
            >
          </td>
        </tr>
        <banner-placeholder v-else />
      </tbody>
    </table>
    <table
      v-if="isAdded('disclaimer')"
      cellspacing="0"
      cellpadding="0"
      border="0"
      role="presentation"
      style="font-size: 0; color: #888; margin-top: 10px;"
    >
      <tbody>
        <tr>
          <td>
            <span
              style="display:block;margin-top:10px;font-family:Arial, Helvetica, sans-serif;font-size: 12px; color: #98A1AB; line-height:16px; margin-top: 10px;"
            >
              {{ addons.disclaimer }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    <table
      v-if="isAdded('custom')"
      cellspacing="0"
      cellpadding="0"
      border="0"
      role="presentation"
      style="font-size: 0; color: #888; margin-top: 10px;"
    >
      <tbody>
        <tr>
          <td>
            <span
                style="display:block;margin-top:10px;font-family:Arial, Helvetica, sans-serif;font-size: 12px; color: #98A1AB; line-height:16px; margin-top: 10px;"
              >
                {{ addons.custom }}
              </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import EmailTemplate from './emailTemplate'
import Avatar from './components/Avatar'
import BannerPlaceholder from './components/BannerPlaceholder'
import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    Avatar,
    BannerPlaceholder
  },
  extends: EmailTemplate,

  data() {
    return {
      items: {
        type: Array,
        default: undefined
      },
    }
  },

  mounted: function () {
  
  },

  computed: {
    ...mapState(['socials']),
    ...mapGetters({
      socials: 'socials',
      socialsLink: 'socialsLink',
    }),
  },

  watch: {
    socials: {
        handler: function (val, oldVal) { 
          this.getSocialsStates();     
        },
        deep: true
    }
  },

  async created() {
    this.$store.watch((state, getters) => getters.socialsLink,
      (newValue, oldValue) => {
        return;
      })
    this.$store.watch(
      (state, getters) => getters.socials,
      (newValue, oldValue) => {
        this.getSocialsStates();
      },
    );
  },

  methods: {

    getSocialsStates () {
      const socials = this.$store.getters.socials;
      this.items = [];
      let items = [];
    
      socials.forEach(async (item)=>{
        let prepItem = {};
        prepItem.name = item.name;
        prepItem.link = item.link;

        let awaitedImg = await this.getEncodedSvgBase64(item.icon);
        prepItem.src = awaitedImg;
        prepItem.alt = "social-icon-"+item.icon;

        items.push(prepItem);
      })

      this.items = items;
    },
    getEncodedSvgBase64 (icon) {
      return new Promise(resolve => {
        const url = require("@/assets/image/" + icon + ".png");
        const xhr = new XMLHttpRequest();
        xhr.onload = function () {
          const codes = new Uint8Array(xhr.response);
          const bin = String.fromCharCode.apply(null, codes);
          resolve("data:image/png;base64," + btoa(bin));
        };
        xhr.open('GET', url);
        xhr.responseType = 'arraybuffer';
        xhr.send();
      });
    },
  }
}
</script>

